/** @jsx jsx */
import { jsx } from "theme-ui"

const SectionHeading = props => {
    return (
        <div sx={{my: (props.smallMargin ? 5 : 9) }}>
            <span sx={{
                fontSize: 0,
                color: (props.variant === "light" ? 'white' : 'neutral600'),
                textTransform: 'uppercase',
                fontWeight: 'heading',
                textAlign: `${props.textAlign}`,
                my: 0
            }}>{props.caption}</span>
            <h2 sx={{
                fontSize: 5,
                fontFamily: 'heading',
                fontWeight: 'heading',
                lineHeight: 1,
                my: 0,
                textAlign: `${props.textAlign}`
            }}>{props.children}</h2>
        </div>
    )
}

export default SectionHeading